import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const Container = styled.div`
  max-width: 900px;
  height: 40px;

  right: 60px;
  bottom: 10px;
  position: absolute;

  z-index: 2000;

  border-radius: 8px;
  align-items: center;
  justify-content: space-between;

  display: grid;
  grid-template-columns: auto auto auto;

  box-shadow: 0px 7px 6px -1px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 0px 7px 6px -1px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0px 7px 6px -1px rgba(0, 0, 0, 0.15);

  @media (max-width: 768px) {
    max-width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 0;
    height: 44px;
    overflow: clip;
  }
`;

export const BackButton = styled.div<{ isActive?: boolean }>`
  cursor: ${({ isActive }) => (isActive ? 'pointer' : 'not-allowed')};
  user-select: none;

  width: 40px;
  height: 40px;

  position: relative;
  top: 3px;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: #fff;
  border-radius: 8px 0 0 8px;

  & > svg {
    & > path {
      fill: ${({ isActive }) => (isActive ? COLOR_OPTIONS.NEUTRAL_60 : COLOR_OPTIONS.NEUTRAL_20)};
    }
  }

  @media (max-width: 768px) {
    border-radius: 0;
    width: 48px;
    height: 44px;
    -webkit-tap-highlight-color: transparent;
  }
`;

export const ForwardButton = styled.div<{ isActive?: boolean }>`
  cursor: ${({ isActive }) => (isActive ? 'pointer' : 'not-allowed')};
  user-select: none;

  width: 40px;
  height: 40px;

  border-radius: 0 8px 8px 0;

  position: relative;
  top: 3px;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: #fff;
  box-shadow: -4px 0px 12px rgba(0, 0, 0, 0.15);

  & > svg {
    & > path {
      fill: ${({ isActive }) => (isActive ? COLOR_OPTIONS.NEUTRAL_60 : COLOR_OPTIONS.NEUTRAL_20)};
    }
  }

  @media (max-width: 768px) {
    border-radius: 0;
    width: 48px;
    height: 44px;
    -webkit-tap-highlight-color: transparent;
  }
`;

export const ListDays = styled.div`
  display: grid;
  grid-template-columns: repeat(15, max-content);
  height: 46px;

  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
    height: 50px;
  }
`;

export const Day = styled.div<{ isSelected?: boolean }>`
  cursor: pointer;
  width: 80px;
  height: 40px;

  background-color: ${COLOR_OPTIONS.NEUTRAL_10};
  top: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.3s ease;

  & > div {
    display: flex;
    align-items: center;

    & span:first-child {
      margin-right: 5px !important;
    }
  }

  &:hover {
    background-color: ${COLOR_OPTIONS.BLUE_20};
  }

  ${({ isSelected }) =>
    isSelected &&
    `
    width: 80px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${COLOR_OPTIONS.BLUE_20};
    position: relative;

    &:before {
      content: '';
      height: 6px;
      width: 80px;
      position: absolute;
      top: -6px;
      background-color: ${COLOR_OPTIONS.BLUE_40};
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }

    & div:nth-child(1) {
      & span:first-child {
        color:${COLOR_OPTIONS.BLUE_60} !important;
      }

      & span:nth-child(2) {
        color: ${COLOR_OPTIONS.BLUE_80} !important;
      }
    }
  `}

  & div:nth-child(2) {
    width: 20px;
    height: 4px;
    border-radius: 8px;
    background-color: ${COLOR_OPTIONS.BLUE_60};
    position: absolute;
    bottom: 5px;
  }

  @media (max-width: 768px) {
    scroll-snap-align: start;
    height: 44px;
    -webkit-tap-highlight-color: transparent;
  }
`;
